<template>
  <div class="heade">
    <logo />
    <div class="nav__info">
      <!-- <div><router-link to="/">HALL OF FAME</router-link></div> -->
      <div class="cont">
        <svg
          viewbox="0 0 27 27"
          style="enable-background: new 0 0 27 27"
          xml:space="preserve"
        >
          <path
            stroke="#fff"
            stroke-width="2"
            fill="none"
            stroke-linecap="round"
          >
            <!-- <animate
              attributeName="d"
              dur="2000ms"
              repeatCount="indefinite"
              values="
M13.5,26C6.6,26,1,20.4,1,13.5S6.6,1,13.5,1S26,6.6,26,13.5S20.4,26,13.5,26z M13.5,26C13.5,26,1,25.4,1,13.5
	S13.5,1,13.5,1 M0.5,13.5l0.5,0 M4.6,13.5l21.9,0;

                M13.5,26C6.6,26,1,20.4,1,13.5S6.6,1,13.5,1S26,6.6,26,13.5S20.4,26,13.5,26z M13.5,26c0,0,12.5-0.6,12.5-12.5
	S13.5,1,13.5,1 M4.6,13.5l21.4,0 M26.3,13.5l0.1,0;
                "
            /> -->
            <animate
              attributeName="d"
              dur="2000ms"
              repeatCount="indefinite"
              values="
M13.5,26C6.6,26,1,20.4,1,13.5S6.6,1,13.5,1S26,6.6,26,13.5S20.4,26,13.5,26z M13.5,26C13.5,26,1,25.4,1,13.5
	S13.5,1,13.5,1 M0.6,13.5h25.9;

                M13.5,26C6.6,26,1,20.4,1,13.5S6.6,1,13.5,1S26,6.6,26,13.5S20.4,26,13.5,26z M13.5,26c0,0,12.5-0.6,12.5-12.5
	S13.5,1,13.5,1 M0.6,13.5h25.9;
                "
            />

            <!-- <animate
              attributeName="d"
              dur="2000ms"
              repeatCount="indefinite"
              values="
                M13.5,26C6.6,26,1,20.4,1,13.5S6.6,1,13.5,1S26,6.6,26,13.5S20.4,26,13.5,26z M13.5,26C13.5,26,1,25.4,1,13.5
	S13.5,1,13.5,1 M0.5,13.5l0.5,0 M7.2,13.5l19.2,0;

                M13.5,26C6.6,26,1,20.4,1,13.5S6.6,1,13.5,1S26,6.6,26,13.5S20.4,26,13.5,26z M13.5,26c0,0,12.5-0.6,12.5-12.5
	S13.5,1,13.5,1 M7.2,13.5l18.7,0 M26,13.5l0.5,0;
                "
            /> -->
          </path>
        </svg>
      </div>
      <div>Milano</div>
      <div><img :src="icon" alt="" class="weatherIcon" /></div>
      <div>
        {{ time | moment("timezone", "Europe/Rome", "ddd h:mm A") }}
      </div>
    </div>
  </div>
</template>

<script>
const axios = require("axios");
import Logo from "./Logo.vue";
export default {
  components: { Logo },
  data() {
    return {
      time: "",
      clock: "",
      icon: "",
    };
  },
  methods: {
    showTime() {
      this.time = new Date();
    },
    weatherIcon(status) {
      if (status === "01d" || status === "01n")
        this.icon = "/weatherIcon/icon_clearsky.svg";
      else if (status === "02d" || status === "02n")
        this.icon = "/weatherIcon/icon_fewclouds.svg";
      else if (status === "03d" || status === "03n")
        this.icon = "/weatherIcon/icon_fewclouds.svg";
      else if (status === "04d" || status === "04n")
        this.icon = "/weatherIcon/icon_brokenclouds.svg";
      else if (status === "09d" || status === "09d")
        this.icon = "/weatherIcon/icon_showerain.svg";
      else if (status === "10d" || status === "10n")
        this.icon = "/weatherIcon/icon_rain.svg";
      else if (status === "11d" || status === "11n")
        this.icon = "/weatherIcon/icon_storm.svg";
      else if (status === "13d" || status === "13n")
        this.icon = "/weatherIcon/icon_snow.svg";
      // else if (status === "50d" || status === "50n")
      else this.icon = "/weatherIcon/icon_mist.svg";

      // if (status === "Clear")
      //   this.icon = "/weatherIcon/source_icons_sun-light.svg";
      // else if (status === "Thunderstorm")
      //   this.icon = "/weatherIcon/source_icons_thunderstorm.svg";
      // else if (status === "Drizzle")
      //   this.icon = "/weatherIcon/source_icons_rain.svg";
      // else if (status === "Rain")
      //   this.icon = "/weatherIcon/source_icons_heavy-rain.svg";
      // else if (status === "Snow")
      //   this.icon = "/weatherIcon/source_icons_snow.svg";
      // else if (status === "Cloud")
      //   this.icon = "/weatherIcon/source_icons_cloud.svg";
      // // else if(status === 'Mist') this.icon = "../assets/img/weatherIcon/source_icons_cloud.svg"
      // else if (
      //   [
      //     "Mist",
      //     "	Smoke",
      //     "Haze",
      //     "Dust",
      //     "Fog",
      //     "Sand",
      //     "	Ash",
      //     "Squall",
      //     "Tornado",
      //   ].indexOf(status) > -1
      // )
      //   this.icon = "/weatherIcon/source_icons_cloud.svg";
    },
    getImgUrl(pic) {
      console.log(require.context(pic));
      return require.context(pic);
    },
  },
  mounted() {
    this.clock = setInterval(this.showTime, 1000);
    axios
      .get(
        "https://api.openweathermap.org/data/2.5/weather?id=3173434&appid=25da9961de73ef1c759f15ede9def780"
      )
      .then((res) => {
        console.log(res.data.weather[0].main);
        this.weatherIcon(res.data.weather[0].icon);
      });
  },
  beforeDestroy() {
    clearInterval(this.clock);
  },
};
</script>

<style lang="scss" scoped>
.heade {
  position: fixed;
  z-index: 99999;
  width: 100vw;
  top: 0;
  display: flex;
  justify-content: space-between;
}
.nav__info {
  div {
    margin-left: 20px;
  }
  a {
    color: white;
    text-decoration: none;
    &:hover {
      text-decoration: line-through;
    }
  }
  display: flex;
  justify-content: flex-end;
  padding-top: 32px;
  padding-right: 38px;
  font-family: Lausanne;
  font-size: 28px;
    @media screen and (max-width:767px) {
    display: none;
  }
}
.cont {
  width: 27px;
}

.weatherIcon {
  // filter: invert(100%);
  margin-top: -5px;
  width: 42px;
}
</style>
